export default "__VITE_ASSET__ZCHQHqSD__"